export const tiny = '4px'
export const mini = '8px'
export const small = '12px'
export const medium = '16px'
export const large = '24px'
export const xLarge = '32px'
export const xxLarge = '40px'
export const xxxLarge = '48px'
